import React from 'react'

export default () =>
  <div className='container-wrapper'>
    <h1 style={{textAlign: 'center', padding: '2em 0'}}>Not Found</h1>
  </div>



// WEBPACK FOOTER //
// ./app/containers/PageNotFound.js